module.exports = __webpack_public_path__ + "img/peitongjiuzhen_image_zhuyi.9fd78cfd.png";